<div id="container" class="ac-content page">
  <router-outlet></router-outlet>
</div>
